export default function getScoreSeverity(score: number, scale = 1) {
    if (score >= 7 * scale) {
        return 'High';
    }
    if (score >= 4 * scale) {
        return 'Medium';
    }
    return 'Low';
}
